export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ11.84a2d370.mp3";